import { useState } from 'react';
import { Popover, Chip } from '@mui/material';

// import { IconButton } from '@ui/index';

export const HiddenArray = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  if (!children.length) return null;

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (children.length == 1) {
    return <Chip size="small" label={children} />;
  } else
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Chip size="small" label={children[0]} />
        {
          <>
            <Chip
              color="primary"
              variant="outlined"
              size="small"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
              label={`+${children.slice(1).length}`}
              style={{ marginLeft: 12 }}
            />
            <Popover
              id="mouse-over-popover"
              sx={{
                pointerEvents: 'none',
              }}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
            >
              <div
                style={{
                  display: 'grid',
                  gap: 12,
                  background: '#fcfcfc',
                }}
              >
                {children.slice(1).map((child) => (
                  <Chip key={child} size="small" label={child} />
                ))}
              </div>
            </Popover>
          </>
        }
      </div>
    );
};
